import { render } from "./JoinForm.vue?vue&type=template&id=5ec591d6&scoped=true"
import script from "./JoinForm.vue?vue&type=script&lang=js"
export * from "./JoinForm.vue?vue&type=script&lang=js"

import "./JoinForm.vue?vue&type=style&index=0&id=5ec591d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ec591d6"

export default script